import { useContext, useMemo } from 'react'
import { useHistory } from 'react-router-dom'
import GlobalsContext from 'sb-hooks/GlobalsContext'
import actions from 'redux/actions'


const useRedirect = ({ withUseHistory }: { withUseHistory?: boolean } = {}) => {
  const { globals } = useContext(GlobalsContext)
  const { setRedirectLink } = globals || {}
  const history = useHistory()

  return useMemo(() => (link: string, isForce?: boolean) => {
    if (setRedirectLink) {
      setRedirectLink(link)
    }
    else if (withUseHistory) {
      history.push(link)
    }
    else {
      actions.models.router.replace(link, isForce)
    }
  }, [ setRedirectLink ]) // eslint-disable-line react-hooks/exhaustive-deps
}


export default useRedirect
